import React, { useState } from 'react';
import styled from 'styled-components';

import { theme } from 'components';
import FroalaInput from '../react-common/FroalaInput';

export interface SendListingEditorProps {
  body: string;
  setBody: (value: string) => void;
}

const SendListingEditor = (props: SendListingEditorProps) => {
  const { body, setBody } = props;
  return (
    <StyledFroalaInputContainer>
      <FroalaInput model={body} onModelChange={setBody} />
    </StyledFroalaInputContainer>
  );
};

const StyledFroalaInputContainer = styled.div`
  & a {
    color: ${theme.blueBase};
  }
`;
export default SendListingEditor;
